module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_c('strong', {
    staticClass: "bold"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00002#intro"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00004#hetty"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETTY ")]), _vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LEEPING")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00005#lunch"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UNCH WITH ")]), _vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTH ")]), _vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YKES")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00006#great",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE ")]), _vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REAT, ")]), _vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAND, ")]), _vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OAP-")]), _vm._v("W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATER ")]), _vm._v("K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICK")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00007#sidmouth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE ")]), _vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IDMOUTH ")]), _vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETTERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00008#spot",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("POT")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTHIC")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00009#tribute",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE ")]), _vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIBUTE")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00010#pig",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE ")]), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IG ")]), _vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OY")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00011#rode",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ODE BY ALL WITH ")]), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIDE")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00012#easter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE ")]), _vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASTER ")]), _vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00013#first",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE ")]), _vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRST ")]), _vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DAM")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00014#pangs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE ")]), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANGS OF ")]), _vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00015#stone",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TONE ")]), _vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REES")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00016#unknown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("N ")]), _vm._v("U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NKNOWN ")]), _vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILD")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00017#showing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOWING THE ")]), _vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LAG")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00018#swan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00019#damage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00020#dixie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE ")]), _vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IXIE ")]), _vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRLS")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00021#groundlings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROUNDLINGS")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00022#grace",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00023#miss",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISS ")]), _vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISTLETOE")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00024#telegony",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELEGONY")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00025#going",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v(": ")]), _vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OING INTO A ")]), _vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARK ")]), _vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUSE")]), _c('span', {
    staticClass: "smallcaps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00026#signor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v(": ")]), _vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IGNOR ")]), _vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETTIMO")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00027#hot",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v(": ")]), _vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE ")]), _vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OT ")]), _vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WEETS OF ")]), _vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REMONA")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00028#boy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE ")]), _vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OY WHO ")]), _vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URNED INTO A ")]), _vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IKE")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00029#missing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISSING THE ")]), _vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IDNIGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00030#zoo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE ")]), _vm._v("Z"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OO AT ")]), _vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRISTMAS")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00031#old",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LD ")]), _vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILTH")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00032#green",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE ")]), _vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REEN ")]), _vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AN")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00040#soul",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUL ")]), _vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATES")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00041#people",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE ")]), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EOPLE ON ")]), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIVILEGE ")]), _vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILL")])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/thestoriesofjanegardam_00043#about",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BOUT THE ")]), _vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTHOR")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41834ca3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/thestoriesofjanegardam_00001.vue
// module id = 69
// module chunks = 0